import { render } from "./admin_dashboard.html?vue&type=template&id=e3864e62&external"
import script from "./admin_dashboard.js?vue&type=script&lang=js&external"
export * from "./admin_dashboard.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__